import { formatKline, formatLiveCandle } from './chartConfig';

export const fetchKlines = async (symbol, interval, endTime = null) => {
  const baseUrl = process.env.REACT_APP_BINANCE_API_URL;
  let url = `${baseUrl}/api/v3/klines?symbol=${symbol}&interval=${interval}&limit=300`;
  if (endTime) {
    url += `&endTime=${endTime}`;
  }
  const res = await fetch(url);
  if (!res.ok) throw new Error(`Binance API error: ${res.status}`);
  const data = await res.json();
  return data.map(formatKline);
};

export const createKlineSocket = (symbol, interval, onCandle) => {
  const baseUrl = process.env.REACT_APP_BINANCE_WS_URL;
  const url = `${baseUrl}/ws/${symbol.toLowerCase()}@kline_${interval}`;
  const ws = new WebSocket(url);

  ws.onmessage = (e) => {
    try {
      const msg = JSON.parse(e.data);
      if (msg.e === 'kline') onCandle(formatLiveCandle(msg.k));
    } catch (err) {
      console.error('WS parse error:', err);
    }
  };

  ws.onerror = (e) => console.error('WebSocket Error:', e);
  return ws;
};
